import CountryList from "../../components/CountryList";
import React from "react";

// import { Container } from './styles';

const Home: React.FC = () => {
  return (
    <div>
      <CountryList />
    </div>
  );
};

export default Home;
